var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBookmark2(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "800px",
    height: "800px",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7 3.50006V10.0619C7 11.9132 9.37545 12.6744 10.4515 11.168C11.2104 10.1055 12.7896 10.1055 13.5485 11.168C14.6246 12.6744 17 11.9132 17 10.0619V3.50006C17 3.35514 16.9846 3.21381 16.9553 3.07764C20.233 3.39449 21 4.77942 21 8.97606V15.0241C21 19.9453 19.9452 21.0001 15.024 21.0001H8.976C4.05476 21.0001 3 19.9453 3 15.0241V8.97606C3 4.77942 3.76702 3.39449 7.04469 3.07764C7.01541 3.21381 7 3.35514 7 3.50006Z",
    fill: "#A8A8A8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3 8.976C3 4.05476 4.05476 3 8.976 3H15.024C19.9452 3 21 4.05476 21 8.976V15.024C21 19.9452 19.9452 21 15.024 21H8.976C4.05476 21 3 19.9452 3 15.024V8.976Z",
    stroke: "#A8A8A8",
    strokeWidth: 2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7 3.5L7 10.0618C7 11.9131 9.37545 12.6744 10.4515 11.1679V11.1679C11.2104 10.1054 12.7896 10.1054 13.5485 11.1679V11.1679C14.6246 12.6744 17 11.9131 17 10.0618V3.5",
    stroke: "#A8A8A8",
    strokeWidth: 2,
    strokeLinecap: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBookmark2);
export default __webpack_public_path__ + "static/media/bookmark2.0a7acddf4a6f02d66fccc31b3f309979.svg";
export { ForwardRef as ReactComponent };